<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="服务商" label-width="80px" v-if="currentUser.type !== 1">
        <el-select v-model="queryParam.companySn" clearable filterable remote :remote-method="getAgents" :loading="loading" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间" label-width="80px">
        <el-date-picker v-model="queryParam.date" type="month" value-format="YYYY-MM"></el-date-picker>
      </el-form-item>
      <el-form-item label="状态" label-width="80px">
        <el-radio v-model="queryParam.status" label="0">全部</el-radio>
        <el-radio v-model="queryParam.status" label="1">未确认</el-radio>
        <el-radio v-model="queryParam.status" label="2">未发放</el-radio>
        <el-radio v-model="queryParam.status" label="3">已发放</el-radio>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
    <div class="stat-container" v-if="currentUser.type !== 1">
      <div class="color_normal">应付：￥{{stat.payAmount}}</div>
      <div class="color_success">已付：￥{{stat.payedAmount}}</div>
      <div class="color_danger">未付：￥{{stat.unpayAmount}}</div>
    </div>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>佣金列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container"></div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="commissions" border>
      <el-table-column prop="date" label="结算日期" width="100"></el-table-column>
      <el-table-column prop="companyName" label="服务商名称"></el-table-column>
      <el-table-column label="佣金" width="180">
        <template #default="scope">
          <span :class="scope.row.completed ? 'color_success' : scope.row.confirmed ? 'color_warning' : 'color_danger'">￥{{scope.row.amount}}</span>
          <el-link type="primary" href="javascript:;" style="margin-left: 12px;" v-if="scope.row.completed && scope.row.payPic" @click="showPic(scope.row.payPic)">转账单</el-link>
          <el-link type="primary" href="javascript:;" v-if="scope.row.completed && scope.row.receiptPic" @click="showPic(scope.row.receiptPic)">发票</el-link>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <span :class="scope.row.completed ? 'color_success' : scope.row.confirmed ? 'color_warning' : 'color_danger'">
            {{scope.row.completed ? '已发放' : scope.row.confirmed ? '未发放' : '未确认'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注"></el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-link type="primary" :href="scope.row.excelAddress" target="_blank">下载明细</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8, 14, 1]) && !scope.row.confirmed" @click="confirmAmount(scope.row)">确认金额</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8, 14, 6]) && scope.row.confirmed && !scope.row.completed" @click="showSend(scope.row)">确认发放</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8, 14, 6]) && scope.row.completed" @click="showReceipt(scope.row)">上传发票</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 14])" @click="showMemo(scope.row)">备注</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="确认发放" v-model="sendVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="sendForm">
      <el-form-item label="转账单" label-width="88px">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/commission_payed'" :show-file-list="false"
                   :on-success="handleSuccess" :before-upload="beforeUpload">
          <img v-if="sendParam.payPic" :src="$utils.imageSrc(sendParam.payPic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-button type="primary" @click="confirmSend">确认</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="上传发票" v-model="receiptVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="sendForm">
      <el-form-item label="发票" label-width="88px">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/receipt'"
                   :on-success="receiptPicHandleSuccess" :before-upload="receiptPicBeforeUpload">
          <img v-if="receiptParam.receiptPic" :src="$utils.imageSrc(receiptParam.receiptPic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-button type="primary" @click="confirmReceipt">确认</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="备注" v-model="memoVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="memoForm">
      <el-form-item label="备注" label-width="88px">
        <el-input v-model="memoParam.memo"></el-input>
      </el-form-item>
      <el-button type="primary" @click="saveMemo">确认</el-button>
    </el-form>
  </el-dialog>

  <el-image-viewer v-if="showViewer" @close="closeViewer" :url-list="viewerUrls" />
</template>

<script>
export default {
  name: "订单核销返佣",
  props: {
    currentUser: Object
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {
        status: '0'
      },
      commissions: [],
      loading: false,
      agents: [],
      sendVisible: false,
      sendParam: {},
      receiptVisible: false,
      receiptParam: {},
      memoVisible: false,
      memoParam: {},
      showViewer: false,
      viewerUrls: [],
      stat: {}
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file) {
      this.sendParam.payPic = res.data
    },
    receiptPicBeforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    receiptPicHandleSuccess(res, file) {
      this.receiptParam.receiptPic = res.data
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      let param = {
        companySn: this.queryParam.companySn,
        date: this.queryParam.date
      }
      if (this.queryParam.status === '1') {
        param.confirmed = false
      } else if (this.queryParam.status === '2') {
        param.confirmed = true
        param.completed = false
      } else if (this.queryParam.status === '3') {
        param.completed = true
      }
      this.$utils.deleteEmptyProperty(param)
      this.$apis.agentCommission.list(this.pageIndex - 1, this.pageSize, param).then(response => {
        this.commissions = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    confirmAmount(commission) {
      this.$confirm(
          commission.date + '共计￥' + commission.amount +  '，金额确认无误？',
          '确认金额',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        this.$apis.agentCommission.confirmAmount({sn: commission.sn, confirm: true}).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '金额已确认',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showSend(commission) {
      this.sendParam = {
        sn: commission.sn,
        date: commission.date,
        name: commission.companyName
      }
      this.sendVisible = true
    },
    confirmSend() {
      if (!this.sendParam.payPic) {
        this.$message.error('请上传转账单')
        return
      }
      this.$confirm('确认 ' + this.sendParam.date + '【' + this.sendParam.name + '】的佣金已发放？', '确认发放',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        const param = {
          sn: this.sendParam.sn,
          payPic: this.sendParam.payPic,
          complete: true
        }
        this.$apis.agentCommission.confirmSend(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.sendVisible = false
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showReceipt(commission) {
      this.receiptParam = {
        sn: commission.sn,
        receiptPic: commission.receiptPic
      }
      this.receiptVisible = true
    },
    confirmReceipt() {
      if (!this.receiptParam.receiptPic) {
        this.$message.error('请上传发票')
        return
      }
      this.$apis.agentCommission.confirmReceipt(this.receiptParam).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.receiptVisible = false
          this.list()
        }
      })
    },
    showMemo(commission) {
      this.memoParam = {
        sn: commission.sn,
        memo: commission.memo
      }
      this.memoVisible = true
    },
    saveMemo() {
      if (!this.memoParam.memo) {
        this.$message.error('请输入备注')
        return
      }
      this.$apis.agentCommission.saveMemo(this.memoParam).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.memoVisible = false
          this.list()
        }
      })
    },
    showPic(pic) {
      this.viewerUrls = [this.$utils.imageSrc(pic)]
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    },
    getAgents(str) {
      if (str !== '') {
        this.loading = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents = response.data.data
          this.loading = false
        })
      } else {
        this.agents = []
      }
    }
  },
  created() {
    if (this.currentUser.type === 1) {
      this.queryParam.companySn = this.currentUser.sn
    } else {
      this.$apis.agentCommission.stat().then(response => {
        this.stat = response.data
      })
    }
    this.list()
  }
}
</script>

<style scoped>
.stat-container {
  margin: 8px 0;
}
.stat-container div {
  margin-right: 24px;
  display: inline-block;
}
</style>